import { useEffect } from 'react';
import { createPortal } from 'react-dom';

/* closeOnBackdrop·showCloseButton 은 2026-10-13 대표님 요청으로 더했다.
   캠페인 만들기·신규 배송 생성처럼 오래 입력하는 창은 바깥을 잘못 눌러 닫히면 안 되고,
   대신 X 버튼이나 Esc 로만 닫는다(닫으면 고의로 닫은 것으로 본다). 다른 창은 예전 그대로. */
function Modal({
  isOpen, onClose, title, children, size = 'md', className = '', dark = false,
  closeOnBackdrop = true, showCloseButton = false,
}) {
  // ESC 키로 모달 닫기 — 안쪽 입력칸(달력·드롭다운 등)이 Esc 를 먼저 처리했으면 창은 그대로 둔다
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && !e.defaultPrevented) onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sizeClasses = {
    xs: 'max-w-sm',
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl'
  };

  return createPortal(
    <div className="fixed inset-0 z-[9998] flex items-center justify-center animate-fadeIn">
      {/* 배경 오버레이 */}
      <div
        data-testid="modal-backdrop"
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity duration-200"
        onClick={closeOnBackdrop ? onClose : undefined}
      />

      {/* 모달 컨텐츠 */}
      <div className={`relative rounded-lg shadow-xl ${dark ? 'bg-[#1e1e1e] text-neutral-100' : 'bg-white'} ${sizeClasses[size]} ${className || 'w-full'} mx-4 max-h-[90vh] overflow-y-auto transition-opacity duration-200`}>
        {showCloseButton && (
          <button
            type="button"
            aria-label="닫기"
            onClick={onClose}
            className="absolute top-3 right-3 z-10 flex h-8 w-8 items-center justify-center rounded-md text-xl leading-none text-text-gray hover:bg-black/10 hover:text-text-dark"
          >
            ×
          </button>
        )}

        {/* 헤더 */}
        {title && (
          <div className={`px-6 py-4 border-b ${dark ? 'border-neutral-800' : 'border-border-gray'}`}>
            <h2 className={`text-xl font-bold ${dark ? 'text-neutral-100' : 'text-text-dark'}`}>{title}</h2>
          </div>
        )}

        {/* 바디 */}
        <div className="px-6 py-4">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default Modal;
